//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnDestroy,
  OnInit,
  signal,
} from "@angular/core";

//local imports
import { ProjectModel } from "@app/catalog";
import { CloseDialogMessage, CommandModel, Messenger } from "@app/shared";

@Component({
  selector: "export-project",
  standalone: false,
  templateUrl: "./export.component.html",
  styleUrl: "./export.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportComponent implements OnInit, OnDestroy {
  public project = input.required<ProjectModel>();

  constructor(private messenger: Messenger) {}

  ngOnInit(): void {
  }

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public exportCommand = new CommandModel({
    executeAction: () => this.onExport(),
    isValid: signal(false),
  });

  private onExport = async () => {};

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
